import { render, staticRenderFns } from "./TemplateConfirmation.vue?vue&type=template&id=0a0d90ee"
import script from "./TemplateConfirmation.vue?vue&type=script&lang=js"
export * from "./TemplateConfirmation.vue?vue&type=script&lang=js"
import style0 from "./TemplateConfirmation.vue?vue&type=style&index=0&id=0a0d90ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports